import React from 'react';
import { Link } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const HomePage = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary to-blue-900 text-white">
      {/* Hero Section */}
      <section className="max-w-7xl mx-auto px-4 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-5xl font-bold mb-6">Welcome to RailOne</h1>
            <p className="text-xl text-blue-100 mb-8">
              Book your train tickets online with ease. Fast, secure, and convenient railway reservations at your fingertips.
            </p>
            <div className="flex gap-4">
              {user ? (
                <>
                  <Link
                    to="/search"
                    className="px-8 py-3 bg-accent text-gray-900 rounded-lg font-bold hover:bg-yellow-500 transition"
                  >
                    Search Trains
                  </Link>
                  <Link
                    to="/bookings"
                    className="px-8 py-3 bg-white text-primary rounded-lg font-bold hover:bg-gray-100 transition"
                  >
                    My Bookings
                  </Link>
                </>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="px-8 py-3 bg-accent text-gray-900 rounded-lg font-bold hover:bg-yellow-500 transition"
                  >
                    Login
                  </Link>
                  <Link
                    to="/signup"
                    className="px-8 py-3 bg-white text-primary rounded-lg font-bold hover:bg-gray-100 transition"
                  >
                    Sign Up
                  </Link>
                </>
              )}
            </div>
          </div>
          <div className="bg-white text-gray-900 p-8 rounded-lg shadow-2xl">
            <h2 className="text-2xl font-bold mb-6">Quick Book</h2>
            <form className="space-y-4">
              <input
                type="text"
                placeholder="From"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-primary"
              />
              <input
                type="text"
                placeholder="To"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-primary"
              />
              <input
                type="date"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-primary"
              />
              <button
                type="submit"
                className="w-full bg-primary text-white py-2 rounded-lg hover:bg-blue-700 font-semibold"
              >
                Search Trains
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="bg-white text-gray-900 py-20">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12">Why Choose RailOne?</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { icon: '⚡', title: 'Fast Booking', desc: 'Book your tickets in seconds' },
              { icon: '🔒', title: 'Secure Payment', desc: 'Safe and secure payment gateway' },
              { icon: '📱', title: 'Mobile Friendly', desc: 'Book anytime, anywhere' },
              { icon: '🎫', title: 'E-Ticket', desc: 'Get QR coded e-ticket instantly' },
              { icon: '💰', title: 'Best Prices', desc: 'Competitive fares and discounts' },
              { icon: '24/7', title: '24/7 Support', desc: 'Round the clock customer support' },
            ].map((feature, idx) => (
              <div key={idx} className="text-center">
                <div className="text-4xl mb-4">{feature.icon}</div>
                <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
